import { jsx as _jsx } from "react/jsx-runtime";
import { AddContactToClientModal } from '../AddContactToClientModal/AddContactToClientModal';
import { useContactRowModal } from './useContactRowModal';
export const useAddContactToClientModal = (testId)=>useContactRowModal('add_contact_to_client_modal', (contact, dismissModal)=>/*#__PURE__*/ _jsx(AddContactToClientModal, {
            contact: contact,
            dismissModal: dismissModal,
            testId: testId
        }));
